/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEvent.ts                         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/event";

export class AutogenModelEvent<RowType extends ModelRow> extends Endpoint<RowType, RowEventFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEvent extends ModelRow<RowEventFields> {
	constructor(values?: Partial<RowEventFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEventFields {
	company_id: string;
	descr: string;
	display_callin_screen: string;
	id: string;
}

